module.exports = __webpack_public_path__ + "img/icon_map_3.8bdfe4f6.png";